import { render, staticRenderFns } from "./GrowthPublicity.vue?vue&type=template&id=bf9c2b44&scoped=true&"
import script from "./GrowthPublicity.vue?vue&type=script&lang=js&"
export * from "./GrowthPublicity.vue?vue&type=script&lang=js&"
import style0 from "./GrowthPublicity.vue?vue&type=style&index=0&id=bf9c2b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9c2b44",
  null
  
)

export default component.exports